
export const defaultSelectedDateFrom = () => {
    let d = new Date();
    let month  = d.getMonth()+1;
    month  =  month<10 ? '0'+month.toString() : month.toString();
    return `${d.getFullYear()-1}${month}`;
};
export default {
    params: {
        wallet_type : null,
        year_month_from: defaultSelectedDateFrom(),
        account_code : null,
        contact_id : null,
        seller_id : null
    },
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    },
    wallet:[],
    transactions_wallet:[],
    wallet_types:[],
    loading:{
        preloader:false,
        wallet:false,
    },
    clients:[]
};



// WEBPACK FOOTER //
// ./src/modules/historical-by-document/state.js